import React from 'react';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';

import MakeWavesHeroBanner, { MakeWavesHeroBannerProps } from 'Modules/HeroBanner/MakeWaves';
import StaffListingFilter, { StaffListingFiltersProps } from 'Modules/Filters/StaffListing';
import StaffListing, { StaffListingProps } from 'Modules/Listing/Staff/';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: MakeWavesHeroBannerProps;
    staffFilters: StaffListingFiltersProps;
    staffProfiles: StaffListingProps;
}

const Listing: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, staffFilters, staffProfiles } = props;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <MakeWavesHeroBanner {...heroBanner} />
            <Section id="staff_filters" paddingTop={0.75} paddingBottom={1}>
                <Grid>
                    <Col>
                        <StaffListingFilter {...staffFilters} />
                    </Col>
                </Grid>
            </Section>
            <Section id="staff_listing" background paddingTop={1}>
                <Grid>
                    <Col>
                        <StaffListing {...staffProfiles} />
                    </Col>
                </Grid>
            </Section>
        </Main>
    );
};

export default Listing;
